import type {
  CampaignObjective,
  CompensationType,
  DeliverableFormat,
} from "@/hooks/useMarketplaceCampaigns";

export const OBJECTIVES: CampaignObjective[] = [
  "UGC_CONTENT",
  "AWARENESS",
  "SALES",
  "LAUNCH",
  "EVENT",
];

export const COMPENSATION_TYPES: CompensationType[] = ["CASH", "GIFTING", "HYBRID"];

export const DELIVERABLE_FORMATS: DeliverableFormat[] = [
  "REEL",
  "FEED_POST",
  "STORY",
  "CAROUSEL",
  "TIKTOK_VIDEO",
  "YOUTUBE_SHORT",
  "YOUTUBE_VIDEO",
  "UGC_RAW",
];

// Status colour lives in `statusTone.ts` — one map for campaigns, applications,
// collaborations and deliverables, so the four cannot drift apart again.

// The 15/20/18 mirrors that used to live here are gone. The platform take is a
// term of the brand's account: it arrives from the server on BrandProfile and
// on CollaborationMoney, and a client-side copy could only ever be a way to
// display the wrong number for an account on a negotiated rate.

/**
 * What the brand pays and what the creator receives, from an agreed rate.
 *
 * Commission is charged on top of the creator's fee rather than deducted from
 * it — the product promises creators 0% withdrawal cost, so the rate they
 * negotiate is the rate they get.
 */
export function splitCommission(rate: number, commissionPct: number) {
  const commission = (rate * commissionPct) / 100;
  return {
    creatorPayout: rate,
    commission,
    brandTotal: rate + commission,
  };
}
